import type { BuilderContent as Content } from '@builder.io/sdk'

import type { BlogProps } from '@/pages/blog'

import { ProductBlogLayout, DefaultBlogLayout } from './Layouts'

export type BlogLayoutProps = {
  content: Content
} & Omit<BlogProps, 'footer' | 'page'>

export default function BlogLayout(props: BlogLayoutProps) {
  const isProductBlogHome = !!props.product
  const CurrentLayout = !isProductBlogHome ? DefaultBlogLayout : ProductBlogLayout
  return <CurrentLayout {...props} />
}
